"use strict";

export function initInScope($scope) {
    $scope.find('.js-form-auto-submit').on('change', function (e) {
        $(this).closest('form').submit();
    });
}
